// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"390":"8c52de7e","453":"9158081a"}[chunkId] + ".chunk.js";
};